import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryFederalLawSelectOption = makeCreateDictionarySelectOption<IFederalLawErvk>('id', 'number');
